import { useQuery } from '@tanstack/react-query';
import type { AgentsResponse, GetAgentsApiV1AgentsGetSourceEnum } from '../gen/openapi';
import { useApiClient } from './useApiClient';
import { useSource } from './useSource';

export const useAgents = () => {
  const { agents } = useApiClient();
  const source = useSource();

  return useQuery<AgentsResponse, Error>({
    queryKey: ['agents', source],
    queryFn: () =>
      agents.getAgentsApiV1AgentsGet({
        // `undefined` omits the query param entirely. `source` may also be
        // `ring_ui`, which the generated enum does not yet include; cast at the
        // boundary so it is still sent (see useSource).
        source: source as GetAgentsApiV1AgentsGetSourceEnum | undefined,
      }),
    staleTime: 5 * 60 * 1000,
  });
};
